import React from "react";
import Button from "../app/components/Button";
import * as motion from "motion/react-client"
import { useNavigate } from "react-router-dom";
import BackgroundBeamsWithCollision from "../app/components/Ui/background-beams-with-collision";

const Welcome = () => {
    const navigate = useNavigate()
    return (
            <BackgroundBeamsWithCollision>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 2 }}
                className="relative w-screen h-screen overflow-hidden" >
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 3 }}
                    >
                        <img src="/assets/symbol_sequence_white.svg" className="absolute
                            top-1/2 right-0
                            w-[120%] h-[120%]
                            object-contain
                            opacity-5
                            pointer-events-none
                            -translate-y-1/2 
                            translate-x-1/4"/>
                    </motion.div>
                    <div className="flex gap-2 justify-center items-center pt-6">
                        <h2 className="lg:text-3xl font-bold text-white md:text-2xl sm:text-xl text-lg">Bem-vindo(a) ao</h2>
                        <img src='/assets/logo_white.svg' alt="Sequence" className="lg:h-10 lg:mt-[.40rem] md:h-8 md:mt-[.20rem] sm:h-7 sm:mt-[.10rem] h-6 mt-[.2rem]"/>
                    </div>
                    <div className="mt-[20vh]">
                        <h1 className="flex justify-center text-center leading-snug text-white font-medium lg:text-7xl md:text-6xl sm:text-5xl text-3xl">A forma mais inteligente</h1>
                        <h1 className="flex justify-center text-center leading-snug text-white font-medium lg:text-7xl md:text-6xl sm:text-5xl text-3xl">de fazer{'\u00A0'}<span className="text-[#672C71]">contabilidade.</span></h1>
                        <p className="justify-center text-center text-white lg:text-2xl md:text-xl lg:mt-[6vh] sm:mt-[6vh] md:mt-[6vh] mt-[4vh] sm:text-xl text-lg">Tudo que seu escritório precisa.</p>
                        <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ delay: 3, duration: 1 }}
                        >
                            <p className="justify-center text-center text-[#A04CCB] lg:text-2xl md:text-xl sm:text-xl text-lg">Só que mais simples</p>
                        </motion.div>
                    </div>
                    <div className="grid place-items-center">
                        <Button variant="primary" className="lg:w-[25vw] h-14 bg-[#C4C8DD] text-xl md:w-[35vw] sm:w-[45vw] w-[50vw] !text-[#3f1057] lg:mt-[20vh] sm:mt-[25vh] mt-[30vh] border-0 font-bold hover:bg-gray-300" onClick={() => navigate('/login')}>Ir para login</Button>
                    </div>
                </motion.div>
        </BackgroundBeamsWithCollision>
    );
};

export default Welcome;